import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import notificationService from '@/services/NotificationService';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectAppDialog',
  setup(__props, { expose }) {

const visible = ref(false);

const mcpServerUrl = computed(() => process.env.VUE_APP_MCP_SERVER_URL || 'https://mcp.snaplore.com/mcp');

const apps = computed(() => [
  {
    id: 'claude',
    name: 'Claude Code / Claude Desktop',
    command: `claude mcp add snaplore -t http ${mcpServerUrl.value}`,
  },
  {
    id: 'github-copilot',
    name: 'GitHub Copilot',
    command: `// Add to VS Code settings or .vscode/mcp.json
{
  "servers": {
    "snaplore": {
      "type": "http",
      "url": "${mcpServerUrl.value}"
    }
  }
}`,
  },
]);

const show = () => {
  visible.value = true;
};

const close = () => {
  visible.value = false;
};

const copyCommand = async (app: { name: string; command: string }) => {
  try {
    await navigator.clipboard.writeText(app.command);
    notificationService.success(`${app.name} command copied`);
  } catch (error) {
    notificationService.error('Failed to copy command');
  }
};

expose({ show });

return { __sfc: true,visible, mcpServerUrl, apps, show, close, copyCommand }
}

})